module.exports = __webpack_public_path__ + "static/media/cmr_1.c7d76173.jpg";